import api from './api'

/**
 * Servicio para obtener períodos (meses) disponibles para inscripción.
 *
 * Backend endpoint: GET /api/course-periods (baseURL ya incluye /api)
 */
const coursePeriodsService = {
  /**
   * Obtiene períodos disponibles.
   * @param {Object} params
   * @param {string|number} [params.programId]
   * @param {string|number} [params.locationId]
   * @param {string|number} [params.year]
   * @param {string} [params.modalidad]
   * @returns {Promise<Array>}
   */
  async getCoursePeriods(params = {}) {
    const { data } = await api.get('/course-periods', { params })
    return data
  }
}

export default coursePeriodsService

